import React, { useEffect, useMemo } from 'react';
import { Avatar, Breadcrumb, Dropdown, Layout } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import './PageHeader.css';
import { ADMIN_MENU_ITEMS, COMMON_ADMIN_MENU_KEY_LIST } from 'constants/menu';
import { accountStore } from 'store/accountStore';

const { Header } = Layout;

interface PageHeaderProps {
  userName: string;
  breadcrumbItems: BreadcrumbItemType[];
}

const PageHeader: React.FC<PageHeaderProps> = ({ userName, breadcrumbItems }) => {
  const menus = COMMON_ADMIN_MENU_KEY_LIST.concat(accountStore.getMenus());

  const adminMenuList = useMemo(
    () => ADMIN_MENU_ITEMS!.filter(item => menus.includes(item!.key as string)),
    [menus]
  );

  useEffect(() => {
    if (!accountStore.isInit()) {
      accountStore.init().then();
    }
  }, []);

  return (
    <Header className="content-page-header">
      <div className="header-content">
        <div className="breadcrumb-container">
          <Breadcrumb items={breadcrumbItems} />
        </div>
        <div>
          <Dropdown menu={{ items: adminMenuList }} placement="bottomRight">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <Avatar icon={<UserOutlined />} />
              <span>{userName}</span>
            </div>
          </Dropdown>
        </div>
      </div>
    </Header>
  );
};

export default React.memo(PageHeader);
